import Layout from 'components/layout';
import ContentPage from 'components/content-pages';
import { handleContentPageServerSideProps } from 'utils/content-pages';
import { createGetServerSideProps, type HandlerType } from 'utils/next/shared-getServerSideProps';
import { FeaturesType } from 'contexts';
import { TenantIds, TenantTypes } from '@tenants';
import { LocaleManager } from 'utils/locale/locale-manager';

import type { GetServerSidePropsContext } from 'next';
import type { ContentPageProps } from 'types/content-pages';

const handler: HandlerType<ContentPageProps> = async (_context: GetServerSidePropsContext, _features?: FeaturesType, tenant?: TenantTypes) => {
  const requestCookies = _context.req.headers.cookie;
  const localeManager = LocaleManager.forServer(tenant.id, _context.locale, requestCookies);
  const resolvedLocale = localeManager.getCurrentLocale();
  return await handleContentPageServerSideProps(tenant.id, [
    TenantIds.EXP_IN_SERVICE,
    TenantIds.EXP_REALTY_CA,
    TenantIds.EXP_REALTY_US,
    TenantIds.EXP_COMMERCIAL,
  ], '/buy', 'ALL', null, resolvedLocale);
};

export const getServerSideProps = createGetServerSideProps(handler);

export default function BuyPage(props: ContentPageProps) {
  return (
    <Layout>
      <ContentPage {...props} />
    </Layout>
  );
}
